import { ComplexBase } from '@syncfusion/ej2-react-base';
export class DropDownButtonItemDirective extends ComplexBase {
}
DropDownButtonItemDirective.moduleName = 'dropDownButtonItem';
export class DropDownButtonItemsDirective extends ComplexBase {
}
DropDownButtonItemsDirective.propertyName = 'items';
DropDownButtonItemsDirective.moduleName = 'dropDownButtonItems';
